// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2kGfc","inner":"Form_inner__1aUuR","range":"Form_range__h09EV","name":"Form_name__2-RrK","actions":"Form_actions__3Vux_"};